// extracted by mini-css-extract-plugin
export var activeFilterButton = "_qg-c";
export var backButton = "_qg-4";
export var backIcon = "_qg-5";
export var chevronShortcut = "_qg-6";
export var container = "_qg-1";
export var editor = "_qg-8";
export var editorWrapper = "_qg-7";
export var prefix = "_qg-2";
export var searchIcon = "_qg-3";
export var suffix = "_qg-9";
export var suffixContent = "_qg-a";
export var suffixText = "_qg-b";
export var wrapper = "_qg-0";